import * as React from 'react';
import { ICopywriter } from './Entities';
import { ButtonToolbar, Button, Label, ButtonGroup } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';

interface ICopywritersListRowProps {
    copywriter: ICopywriter;
    editCopywriter: (id: number) => void;
    viewlogs: (id: number) => void;
    deleteCopywriter: (id: number) => void;
}

const CopywritersListRow = (props: ICopywritersListRowProps) => {
    return (
        <tr>
            <td>{props.copywriter.name}</td>
            <td>{props.copywriter.email}</td>
            <td>{props.copywriter.phoneNumber}</td>
            <td className="tools">
                <ButtonToolbar className="pull-right btn-group-sm">
                    <ButtonGroup className="center">
                        <Button
                            onClick={() => props.editCopywriter(props.copywriter.id)}
                            bsStyle="primary"
                        >
                            <i className="material-icons">edit</i>
                            {Translate('copywriter/list/row/button-label/edit')}
                        </Button>
                        <Button onClick={() => props.viewlogs(props.copywriter.id)} bsStyle="info">
                            <i className="material-icons">list</i>{' '}
                            {Translate('copywriter/list/row/button-label/logs')}
                        </Button>
                        <Button
                            onClick={() => props.deleteCopywriter(props.copywriter.id)}
                            bsStyle="danger"
                        >
                            <i className="material-icons">delete</i>{' '}
                            {Translate('copywriter/list/row/button-label/delete')}
                        </Button>
                    </ButtonGroup>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default CopywritersListRow;